import { createConsoleLogger, getClient, LogLevel, PollingMode } from '@configcat/sdk'
import type { IConfigCatClient, IConfigCatClientSnapshot } from '@configcat/sdk'

export type FeatureFlagClient = IConfigCatClient
export type FeatureFlagSnapshot = IConfigCatClientSnapshot
export type FeatureFlagClientFactory = (sdkKey: string) => FeatureFlagClient

export const createFeatureFlagClient: FeatureFlagClientFactory = (sdkKey) =>
  getClient(sdkKey, PollingMode.AutoPoll, { logger: createConsoleLogger(LogLevel.Error) })
